import { create } from "zustand";
import dayjs, { Dayjs } from "dayjs";

export interface DateRangeState {
  startDate: Dayjs | null;
  endDate: Dayjs | null;
  setDateRange: (start: Dayjs | null, end: Dayjs | null) => void;
  setStartDate: (start: Dayjs | null) => void;
  setEndDate: (end: Dayjs | null) => void;
  clearRange: () => void;
}

function loadInitialState(key: string): Pick<DateRangeState, "startDate" | "endDate"> {
  void key;
  return { startDate: dayjs().subtract(30, "day"), endDate: dayjs() };
}

export function useDateRangeStore(key: string) {
  const { startDate, endDate } = loadInitialState(key);

  return create<DateRangeState>(set => ({
    startDate,
    endDate,
    setDateRange: (s, e) => {
      set({ startDate: s, endDate: e });
    },
    setStartDate: s => {
      set({ startDate: s });
    },
    setEndDate: e => {
      set({ endDate: e });
    },
    clearRange: () => {
      set({ startDate: null, endDate: null });
    }
  }));
}
